const DEFAULT_REVOKE_OBJECT_URL_DELAY_MS = 100;

type DownloadObjectUrlParams = {
  readonly objectUrl: string;
  readonly filename: string;
};

type DownloadBlobParams = {
  readonly blob: Blob;
  readonly filename: string;
  readonly revokeObjectUrlDelayMs?: number;
};

type DownloadTextContentParams = {
  readonly content: string;
  readonly filename: string;
  readonly mimeType: string;
  readonly revokeObjectUrlDelayMs?: number;
};

export function downloadObjectUrl({ objectUrl, filename }: DownloadObjectUrlParams) {
  const anchor = document.createElement('a');
  anchor.href = objectUrl;
  anchor.download = filename;
  anchor.style.display = 'none';
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
}

export function downloadBlob({
  blob,
  filename,
  revokeObjectUrlDelayMs = DEFAULT_REVOKE_OBJECT_URL_DELAY_MS,
}: DownloadBlobParams) {
  const objectUrl = URL.createObjectURL(blob);
  downloadObjectUrl({ objectUrl, filename });
  // Defer revoke so the browser has time to read the blob before cleanup.
  setTimeout(() => URL.revokeObjectURL(objectUrl), revokeObjectUrlDelayMs);
}

export function downloadTextContent({
  content,
  filename,
  mimeType,
  revokeObjectUrlDelayMs,
}: DownloadTextContentParams) {
  const blob = new Blob([content], { type: mimeType });
  downloadBlob({ blob, filename, revokeObjectUrlDelayMs });
}
